import { render, staticRenderFns } from "./UserButtons.vue?vue&type=template&id=35993fac&scoped=true&"
import script from "./UserButtons.vue?vue&type=script&lang=js&"
export * from "./UserButtons.vue?vue&type=script&lang=js&"
import style0 from "./UserButtons.vue?vue&type=style&index=0&id=35993fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35993fac",
  null
  
)

export default component.exports